// Shared assets & content for the Medufit landing page

export const IMAGES = {
  product: 'https://cdn.magicpatterns.com/uploads/6LLAVpPyyfe5qyMsdsEr2N/WhatsApp_Image_2026-07-26_at_2.19.42_PM.jpg',
  hero: 'https://cdn.magicpatterns.com/uploads/1HhvEtpJFziFc6H1Sc9dyR/ChatGPT_Image_Jul_26,_2026,_09_19_21_PM.png',
  compare: 'https://cdn.magicpatterns.com/patterns/generated-images/2fd6636d-170f-45ad-8551-adaff0f7fe40.jpg',
  lifestyle: 'https://cdn.magicpatterns.com/patterns/generated-images/57014760-c3bb-49df-b22a-07f1ec7866bd.jpg',
  model: 'https://cdn.magicpatterns.com/patterns/generated-images/9b5424dd-58d2-4769-853f-8ec853efa844.jpg',
  benefits: 'https://cdn.magicpatterns.com/uploads/iMKhcxfqsBgQoevrW14dds/ChatGPT_Image_Jul_26,_2026,_05_17_57_PM.png',
  why: 'https://cdn.magicpatterns.com/patterns/generated-images/a5d5d999-4b29-48da-86fb-f0c736858ee4.jpg',
  ingredients: 'https://cdn.magicpatterns.com/patterns/generated-images/bedf98df-a5c2-4ee3-900a-48b671152539.jpg',
  ingredientBackdrop: 'https://cdn.magicpatterns.com/patterns/generated-images/0bd836e4-c68e-4908-9ac2-65c4258bcee7.jpg',
  ingredientHerbal: 'https://cdn.magicpatterns.com/patterns/generated-images/729c0394-3213-452f-b0fa-1ebe2d8789f3.jpg',
  ingredientVitamins: 'https://cdn.magicpatterns.com/patterns/generated-images/293046d4-c095-4ef8-9d37-d9b215ed0061.jpg',
  ingredientVitality: 'https://cdn.magicpatterns.com/patterns/generated-images/2face36c-f183-4647-93d4-fc16ea39345e.jpg',
  ingredientMetabolic: 'https://cdn.magicpatterns.com/patterns/generated-images/f9e472b9-346e-4d1b-8bfe-7704aec8afd4.jpg',
  aboutHero: 'https://cdn.magicpatterns.com/uploads/noJCNmyxg3m4ddEiQJjC97/ChatGPT_Image_Jul_26,_2026,_04_27_42_PM.png',
  aboutSource: 'https://cdn.magicpatterns.com/patterns/generated-images/3f936cb6-381b-499d-8309-091ef8ee70df.jpg',
  aboutCommunity: 'https://cdn.magicpatterns.com/patterns/generated-images/4bf457a0-c4f8-416c-b879-06d007606e24.jpg',
  ingredientsHero: 'https://cdn.magicpatterns.com/patterns/generated-images/a0eb5363-8161-4370-ba4a-1dea529d542a.jpg',
  ingredientsQuality: 'https://cdn.magicpatterns.com/patterns/generated-images/3f432206-9f80-4978-b0e8-88b49b778152.jpg',
}

export type Pkg = {
  id: string
  name: string
  sachets: string
  price: string
  original?: string
  tag?: string
  badge?: string
  note?: string
  popular?: boolean
}

export const PACKAGES: Pkg[] = [
  {
    id: 'starter',
    name: 'Starter Pack',
    sachets: '10 Sachets',
    price: '₹799',
    tag: 'Try It',
    note: 'A gentle way to begin your ritual.',
  },
  {
    id: 'wellness',
    name: '30-Day Wellness Pack',
    sachets: '30 Sachets',
    price: '₹1,990',
    original: '₹2,397',
    badge: 'BEST RESULTS',
    tag: 'Most Popular',
    note: 'Recommended for noticeable daily wellness. Save 17%.',
    popular: true,
  },
  {
    id: 'family',
    name: 'Family Pack',
    sachets: '60 Sachets',
    price: '₹3,690',
    tag: 'Best Value',
    note: 'Enough to share the ritual at home.',
  },
]

export const HERO_BENEFITS = [
  'Daily Energy',
  'Immune Support',
  'Vitality',
  'Zero Added Sugar',
  'Plant Based',
]

export const TRUST_ITEMS = [
  { icon: '🌱', label: 'Plant Based' },
  { icon: '💊', label: '21 Vitamins & Minerals' },
  { icon: '🚫', label: 'Zero Added Sugar' },
  { icon: '🏭', label: 'FDA Registered Facility' },
]

export const INGREDIENTS = [
  {
    name: 'Botanical Foundation',
    desc: 'Plant-powered nourishment and antioxidant support for a balanced everyday routine.',
    bullets: ['Amla fruit extract', 'Ashwagandha root', 'Guduchi & Brahmi'],
    image: 'ingredientHerbal' as const,
  },
  {
    name: 'Daily Essentials',
    desc: 'Vitamins and minerals selected to help cover the nutritional basics, every day.',
    bullets: ['Vitamin C & B-complex', 'Zinc & magnesium', 'Calcium & vitamin D'],
    image: 'ingredientVitamins' as const,
  },
  {
    name: 'Energy & Vitality',
    desc: 'Thoughtful daily nutrients that support steady energy for work, movement, and life.',
    bullets: ['Plant-based nutrition', 'Magnesium support', 'No added sugar'],
    image: 'ingredientVitality' as const,
  },
  {
    name: 'Metabolic Support',
    desc: 'A clean daily blend designed to work naturally with your active lifestyle.',
    bullets: ['Antioxidant-rich botanicals', 'Essential micronutrients', 'Easy daily ritual'],
    image: 'ingredientMetabolic' as const,
  },
]

export const BODY_PARTS = [
  { key: 'brain', label: 'Brain', desc: 'Brahmi and B-vitamins support focus and mental clarity through the day.' },
  { key: 'heart', label: 'Heart', desc: 'Plant nutrients and minerals support healthy cardiovascular function.' },
  { key: 'immune', label: 'Immune System', desc: 'Amla, Guduchi and zinc help support your natural defenses.' },
  { key: 'gut', label: 'Gut', desc: 'Fibre and herbal extracts support comfortable daily digestion.' },
  { key: 'muscles', label: 'Muscles', desc: 'Plant protein and magnesium support strength and recovery.' },
  { key: 'bones', label: 'Bones', desc: 'Calcium, vitamin D and K help maintain strong bones.' },
  { key: 'skin', label: 'Skin', desc: 'Antioxidants and vitamin C support a natural, healthy glow.' },
  { key: 'hair', label: 'Hair', desc: 'Biotin and minerals nourish hair from within.' },
]

export const BENEFITS = [
  { title: 'Daily Energy', desc: 'Fuel your everyday lifestyle.' },
  { title: 'Immune Support', desc: 'Daily nutritional support.' },
  { title: 'Plant-Based Nutrition', desc: 'Clean, considered ingredients.' },
  { title: 'Zero Added Sugar', desc: 'Nothing unnecessary.' },
  { title: 'One-Minute Routine', desc: 'Mix. Drink. Done.' },
]

export const STEPS = [
  { n: '01', title: 'Open Sachet', desc: 'Tear open one single-serve sachet.' },
  { n: '02', title: 'Pour Into Water', desc: 'Add to 250ml of cold water.' },
  { n: '03', title: 'Mix', desc: 'Stir or shake for a few seconds.' },
  { n: '04', title: 'Drink Daily', desc: 'Enjoy every morning.' },
]

export const COMPARE = [
  { feature: 'One Daily Sachet', medufit: true, others: false },
  { feature: 'Ayurvedic Herbs', medufit: true, others: false },
  { feature: '21 Vitamins & Minerals', medufit: true, others: false },
  { feature: 'Easy to Carry', medufit: true, others: false },
  { feature: 'Mix With Water', medufit: true, others: false },
  { feature: 'Plant Based', medufit: true, others: 'varies' as const },
]

export const DOCTORS = [
  { name: 'Dr. Ananya Rao', role: 'Ayurvedic Physician', quote: 'It brings ancient formulations into a format people will actually keep up with.' },
  { name: 'Dr. Vikram Nair', role: 'General Physician', quote: 'A convenient way for patients to cover daily micronutrient gaps.' },
  { name: 'Dr. Meera Iyer', role: 'Nutritionist', quote: 'Clean, plant-based, and thoughtfully dosed — I recommend it.' },
  { name: 'Dr. Sanjay Gupta', role: 'Integrative Medicine', quote: 'A sensible bridge between tradition and modern nutrition.' },
  { name: 'Dr. Priya Menon', role: 'Wellness Consultant', quote: 'Simplicity is what makes a routine stick, and this delivers it.' },
]

export const REVIEWS = [
  { name: 'Riya S.', text: 'Replaced my whole shelf of supplements with one sachet. My mornings feel calmer and more energised.', rating: 5 },
  { name: 'Arjun M.', text: 'Tastes clean, mixes instantly, and I actually stick with it. That’s the real win.', rating: 5 },
  { name: 'Neha K.', text: 'Love that it’s plant based and sugar free. My skin looks better after a month.', rating: 5 },
  { name: 'Kabir D.', text: 'Perfect for travel. One sachet in my bag and my nutrition is sorted.', rating: 5 },
  { name: 'Sana P.', text: 'The Ayurvedic angle sold me and the convenience keeps me coming back.', rating: 5 },
  { name: 'Rahul V.', text: 'Noticeably steadier energy without the crash. Simple and effective.', rating: 5 },
]

export const FAQS = [
  { q: 'What is Medufit?', a: 'Medufit is a daily complete nutrition powder that blends Ayurvedic herbs with 21 essential vitamins and minerals in one convenient single-serve sachet.' },
  { q: 'How do I use it?', a: 'Tear open one sachet, pour into 250ml of cold water, mix for a few seconds, and drink — ideally every morning.' },
  { q: 'Can I drink it daily?', a: 'Yes. Medufit is formulated for daily use as part of your everyday wellness routine.' },
  { q: 'What’s inside?', a: 'Ayurvedic herbs like Amla, Ashwagandha, Guduchi and Brahmi, plus 21 vitamins & minerals and plant-based nutrition, with zero added sugar.' },
  { q: 'Who should use it?', a: 'Anyone looking to simplify their daily supplements — students, professionals, parents and active adults alike.' },
  { q: 'Is it vegetarian?', a: 'Yes, Medufit is 100% plant based and vegetarian.' },
  { q: 'Is it sugar free?', a: 'Yes, Medufit contains zero added sugar.' },
]
